import * as React  from 'react';
import { useState } from 'react';
import axios from 'axios';

interface TicketInfo {
  created_at: string;
  created_datetime: string;
  valid_period_day: string;
  unit_price: number;
  deleted_at: string;
  price: number;
  name: string;
  expired_at: string;
}

const PER = 10;

const Index = (props) => {
  const [marker, setMarker] = useState(PER);
  const [limit, setLimit] = useState(PER);
  const [TicketInfo, setTicketInfo] = useState(props.ticket_info);

  const loadList = () => {
    // stateに即座に反映されないので一旦変数に入れてそっちを使う
    const newLimit = limit + PER
    setLimit(newLimit)
    axios.get<TicketInfo[]>(
      '/api/internal/tickets/data/index?company_id=' + props.company_id
                                   + '&limit=' + newLimit
    ).then(function (response) {
      setTicketInfo(response.data);
    }).catch(function (error) {
    }).finally(() => {
      setMarker(marker + PER);
    });
  }

  return (
    <>
      <h4>残り枚数: {props.remain_count}枚</h4>
      <br/>
      <div className="table-responsive message-table-content">
        <table id="notice_table" className="table table-bordered">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center col-lg-2">発行日</th>
              <th scope="col" className="text-center col-lg-2">有効日数</th>
              {props.is_admin && <th scope="col" className="text-center col-lg-2">価格</th>}
              <th scope="col" className="text-center col-lg-2">消費日時</th>
              <th scope="col" className="text-center col-lg-2">チケットマスタ</th>
            </tr>
          </thead>
          <tbody>
            {TicketInfo.map((ticket, i) => (
              <tr key={i}>
                <td className="text-center">{ticket.created_at}</td>
                <td className="text-center">{ticket.valid_period_day}日</td>
                {props.is_admin && <td className="text-center">{ticket.unit_price.toLocaleString()}円</td>}
                <td className="text-center">{ticket.deleted_at ?
                                             ticket.deleted_at :
                                             new Date(ticket.expired_at) < new Date() ?
                                             <span className="expire-ticket-text">期限切れ</span> :
                                             <span className="unused-ticket-text">未使用</span>}</td>
                <td className="text-center">{ticket.name}</td>
              </tr>
            )).slice(0, marker)}
          </tbody>
        </table>
        {
          TicketInfo.length >= marker
            ? <div className="text-center"><button className="btn btn-default more-btn" onClick={loadList}>もっと表示 ▼</button></div>
            : ''
        }
      </div>
    </>
  )
}

export default Index
